<section class="facet-filter">
  <h3 class="facet-subtitle" attr.aria-label="{{ 'adura.domain.label' | translate }}">{{ 'adura.domain.label' | translate }}</h3>
  <div>
    <ng-container *ngIf="!this.bereich || this.bereich.length === 0">
      <p><small>{{ 'search.noFilter' | translate }}</small></p>
    </ng-container>
    <nav [attr.aria-label]="'adura.domain.list' | translate">
      <div class="list-inline tags">
        <ng-container *ngFor="let state of bereich">
          <div class="flex-container">
            <input type="checkbox" class="filter-checkbox sr-only" id="{{state.id}}"
                   (click)="changeBereich(state.id)"
                   [checked]="isBereichActive(state.id)">
            <label class="filter-checkbox-label" [ngClass]="(state.count === 0)?'filter-element-background':''"
                   for="{{state.id}}"
                   role="checkbox"
                   [attr.aria-label]="('adura.domain.label' | translate) + ': ' + (state.name | translate) + ', ' +
                   ('global.total' | translate) + ': ' + state.count"
                   [attr.aria-checked]="(isBereichActive(state.id))?'true':'false'">
              {{ state.name | translate }}
            </label>
            <span class="filter-checkbox-number" aria-hidden="true">{{ state.count}}</span>
          </div>
        </ng-container>
      </div>
    </nav>
  </div>
</section>
